import { Component } from '@theme/component';

/**
 * Mom & Me look panel: syncs hover highlight between image hotspots and product cards.
 */
export class MomAndMeLookPanel extends Component {
  /** @type {AbortController | null} */
  #abortController = null;

  connectedCallback() {
    super.connectedCallback();
    this.#bindHoverSync();
  }

  disconnectedCallback() {
    super.disconnectedCallback();
    this.#abortController?.abort();
    this.#abortController = null;
  }

  #bindHoverSync() {
    this.#abortController?.abort();
    this.#abortController = new AbortController();
    const { signal } = this.#abortController;

    this.querySelectorAll('[data-overlay-id]').forEach((item) => {
      if (!(item instanceof HTMLElement)) return;

      item.addEventListener(
        'mouseenter',
        () => {
          this.#setActiveOverlay(item.dataset.overlayId ?? '');
        },
        { signal }
      );

      item.addEventListener(
        'mouseleave',
        (event) => this.#clearOverlayIfLeaving(event, item.dataset.overlayId),
        { signal }
      );

      item.addEventListener(
        'focusin',
        () => {
          this.#setActiveOverlay(item.dataset.overlayId ?? '');
        },
        { signal }
      );

      item.addEventListener(
        'focusout',
        (event) => this.#clearOverlayIfLeaving(event, item.dataset.overlayId),
        { signal }
      );
    });
  }

  /**
   * @param {FocusEvent | MouseEvent} event
   * @param {string | undefined} overlayId
   */
  #clearOverlayIfLeaving(event, overlayId) {
    const relatedTarget = event.relatedTarget;

    if (
      overlayId &&
      relatedTarget instanceof Element &&
      relatedTarget.closest(`[data-overlay-id="${overlayId}"]`)
    ) {
      return;
    }

    if (this.dataset.activeOverlay === overlayId) {
      this.#setActiveOverlay('');
    }
  }

  /**
   * @param {string} overlayId
   */
  #setActiveOverlay(overlayId) {
    if (overlayId) {
      this.dataset.activeOverlay = overlayId;
    } else {
      delete this.dataset.activeOverlay;
    }

    this.querySelectorAll('[data-overlay-id]').forEach((element) => {
      if (!(element instanceof HTMLElement)) return;
      element.classList.toggle('is-highlighted', element.dataset.overlayId === overlayId);
    });
  }
}

if (!customElements.get('mom-and-me-look-panel')) {
  customElements.define('mom-and-me-look-panel', MomAndMeLookPanel);
}
